module.exports = __webpack_public_path__ + "static/img/minicon5.fd67d4a7.png";